<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Vistoria</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.id) }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Protocolo</label>
                <div class="field-label field-label-center">{{ objView.xsequencia }}</div>
            </div>            

            <div class="form-item-char10">
                <label class="label-caption">Data</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtvistoria) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Estabelecimento</label>
                <div class="field-label">{{ objView.nmestabelecimento }}</div>
            </div>

            <div class="form-item-char30">
                <label class="label-caption">Responsável</label>
                <div class="field-label">{{ objView.nmresponsavel }}</div>
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item-char20">
                <label class="label-caption">Início vistoria</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateTimeFromJson(objView.dhinicio) }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Encerramento vistoria</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateTimeFromJson(objView.dhencerramento) }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Validade</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtvalidade) }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Rotina</label>
                <div class="field-label field-label-center">{{ objView.nmatv_vistoria_rotina }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Coleta</label>
                <div class="field-label field-label-center">{{ objView.nmatv_coleta_oficial }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Outra</label>
                <div class="field-label field-label-center">{{ objView.nmatv_outra }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Descrição Outra</label>
                <div class="field-label">{{ objView.atv_outra_descricao }}</div>
            </div>
        </div>
        

        <div class="row row-space">
            <div class="form-item-char40">
                <label class="label-caption">SIM</label>
                <div class="field-label">{{ objView.nmsim }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Fiscal</label>
                <div class="field-label">{{ objView.nmvistoriador }}</div>
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">PAC-01</label>
                <div class="field-label field-label-center" :class="getClass(objView.pac01)">{{ objView.pac01 }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">PAC-02</label>
                <div class="field-label field-label-center" :class="getClass(objView.pac02)">{{ objView.pac02 }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">PAC-03</label>
                <div class="field-label field-label-center" :class="getClass(objView.pac03)">{{ objView.pac03 }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">PAC-04</label>
                <div class="field-label field-label-center" :class="getClass(objView.pac04)">{{ objView.pac04 }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">PAC-05</label>
                <div class="field-label field-label-center" :class="getClass(objView.pac05)">{{ objView.pac05 }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">PAC-06</label>
                <div class="field-label field-label-center" :class="getClass(objView.pac06)">{{ objView.pac06 }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">PAC-07</label>
                <div class="field-label field-label-center" :class="getClass(objView.pac07)">{{ objView.pac07 }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">PAC-08</label>
                <div class="field-label field-label-center" :class="getClass(objView.pac08)">{{ objView.pac08 }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">PAC-09</label>
                <div class="field-label field-label-center" :class="getClass(objView.pac09)">{{ objView.pac09 }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">PAC-10</label>
                <div class="field-label field-label-center" :class="getClass(objView.pac10)">{{ objView.pac10 }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">PAC-11</label>
                <div class="field-label field-label-center" :class="getClass(objView.pac11)">{{ objView.pac11 }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">PAC-12</label>
                <div class="field-label field-label-center" :class="getClass(objView.pac12)">{{ objView.pac12 }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">PAC-13</label>
                <div class="field-label field-label-center" :class="getClass(objView.pac13)">{{ objView.pac13 }}</div>
            </div>
        </div>
        
        
        <div class="row-end">
            <button type="button" @click="visualizarLaudo">Laudo</button>
            <button type="button" @click="listarImagens">Fotos</button>
            <button type="button" @click="closeForm">Retornar</button>
        </div>
    </div>
    

    <div v-if="lsNc.length>0" class="table-wrapper">
        <table>
            <thead><tr>
                <th class="col-width-char10">PAC</th>
                <th class="col-width-char10">Prazo</th>
                <th class="col-width-char20">Status</th>
                <th class="col-width-char10">Previsão</th>
                <th>Correção</th>
            </tr></thead>
            <tbody>
                <tr v-for="(obj, index) in lsNc" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td>{{ obj.nmpac }}</td>
                    <td class="center">{{ Funcoes.formatDateFromJson(obj.dtprazo) }}</td>
                    <td>{{ obj.xstatus }}</td>
                    <td class="center">{{ Funcoes.formatDateFromJson(obj.acdtprevista) }}</td>
                    <td>{{ obj.acdetalhamento }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    

    <ModalImagem v-model:show="showImageModal">
        <div v-if="currentImage">
            <img :src="`data:image/jpeg;base64,${currentImage.fname}`" :alt="currentImage.xtipo" class="modal-image">
            <button @click="nextImage">Próxima Imagem</button>
        </div>
    </ModalImagem>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';
import ModalImagem from '@/components/utils/ModalImagem.vue';

const emit = defineEmits(['close']);
const props = defineProps({idView: {type: Number, default: 0}});

const currentImageIndex = ref(0);
const isLoading = ref(false);
const lsImagens = ref([]);
const lsNc = ref([]);
const msgAlerta = ref(null);
const objView = ref({});
const showImageModal = ref(false);


const closeForm = () => {emit('close');}


function getClass(value) {
    if (!value) return ''; // protege contra undefined
    switch (value) {
        case 'CF': return 'cf';
        case 'CR': return 'cr';
        case 'NC': return 'nc';
        case 'NA': return 'na';
        default: return '';
    }
}

const getImagem = async(idAnexo) => {
    try{
        const dados = {id: idAnexo, strparam1: '1'};
        const req = await Api.genericPost('/lspla/pla06_anexo_base64', dados);
        return req.anexo;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;}
};

const lerDados = async() => {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const req = await Api.genericPost('/lspla/pla06', {idep: globalStore.idep, id: props.idView});
        Object.assign(objView.value, req[0]);
        
        const reqNC = await Api.genericPost('/lspla/pla06/nc', {idep: globalStore.idep, idreferencia: props.idView});
        lsNc.value = reqNC;

    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}

const listarImagens = async() => {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const req = await Api.genericPost('lspla/pla06_anexos', {id: props.idView, tipo: 1});
        if (req.length == 0){
            msgAlerta.value= 'Vistoria não possui imagens anexadas';
        }else{
            for (const img of req) {
                img.fname = await getImagem(img.id); // Fetch base64 string and store it in fname
            }
            lsImagens.value = req;
            currentImageIndex.value = 0;
            showImageModal.value = true;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}

const nextImage = () => {
    if (currentImageIndex.value < lsImagens.value.length - 1){
        currentImageIndex.value++;
    }else{
        showImageModal.value = false;
    }
}

const currentImage = computed(() => lsImagens.value[currentImageIndex.value]);

const visualizarLaudo = async() => {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const req = await Api.genericPost('/lspla/pla06_anexo_base64', {id:0, idreferencia: props.idView, strparam1: 'L'});
        const pdfBase64 = req.anexo;
        const pdfWindow = window.open("");
        const iframe = pdfWindow.document.createElement("iframe");
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        iframe.src = "data:application/pdf;base64," + encodeURIComponent(pdfBase64);
        pdfWindow.document.body.appendChild(iframe);
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
};

onMounted(lerDados);
</script>